export const awsOidcSteps = [
  {
    title: "Set up an OIDC trust",
    items: [
      {
        kind: "markdown",
        content:
          "Register 3B as an OpenID Connect identity provider in your AWS account:\n\n1. Open the [IAM identity providers page](https://console.aws.amazon.com/iam/home#/identity_providers)\n2. Choose **Add provider** → **OpenID Connect**\n3. For **Provider URL**, enter the URL shown below\n4. For **Audience**, enter the value shown below\n5. Click **Add provider**",
      },
      {
        kind: "copyable",
        label: "Provider URL",
        value: "{OIDC_PROVIDER_URL}",
      },
      {
        kind: "copyable",
        label: "Audience",
        value: "connected-app:{CONNECTED_APP_ID}",
      },
    ],
  },
  {
    title: "Create an IAM role",
    items: [
      {
        kind: "markdown",
        content:
          "Create a role that trusts the 3B OIDC provider:\n\n1. Open the [IAM roles page](https://console.aws.amazon.com/iam/home#/roles) and click **Create role**\n2. Choose **Web identity**, select the 3B provider you just added, and select the audience shown above\n3. Attach the permissions your workflows need\n4. Name the role and create it\n5. Copy the **Role ARN** from the role summary",
      },
    ],
  },
  {
    title: "Enter the role details",
    items: [
      {
        kind: "input",
        label: "Role ARN",
        placeholder: "arn:aws:iam::123456789012:role/My3BRole",
        required: true,
        target: { kind: "configuration", field: "roleArn" },
      },
    ],
  },
] as const;
